import { ILocation } from 'core/router/location-routes/interface';
import { FactoryKracow } from './location-routes/factory-krakow';
import { officeWarszawa } from './location-routes/office-warszawa';
import { itCenterKracow } from './location-routes/it-centre-krakow';
import { CommunityServiceKracow } from './location-routes/community-service-krakow';
import { AcrossCountry } from './location-routes/across-country';

const LocationData: ILocation[] = [itCenterKracow, CommunityServiceKracow, FactoryKracow, officeWarszawa, AcrossCountry];
export default LocationData;
